import * as Actions from './FinancialPlanWarningActions';

const defined = obj => obj || {};

const ShowReducer = (state, action) => {
  const currentState = defined(state[action.clientId]);
  switch (action.warningType) {
    case Actions.WARNING_TYPE_NEGATIVE_CASHFLOW: {
      return {
        ...state,
        [action.clientId]: {
          ...currentState,
          warningType: action.warningType,
          warningMessage: action.warningMessage,
        },
      };
    }
    default:
      return state;
  }
};

export default (state = {}, action) => {
  const { type } = action;

  switch (type) {
    case Actions.SHOW: {
      return ShowReducer(state, action);
    }
    case Actions.HIDE: {
      return {
        ...state,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          [action.key]: true,
        },
      };
    }
    case Actions.HIDE_ALL: {
      return {
        ...state,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          warningMessage: null,
        },
      };
    }
    default: {
      return state;
    }
  }
};
